import { render, staticRenderFns } from "./LineaInfoCard.vue?vue&type=template&id=22f81ef8&"
import script from "./LineaInfoCard.vue?vue&type=script&lang=js&"
export * from "./LineaInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports